<template>
     <div class="contains">
         <div class="content-tit">
           <h2>员工管理</h2>
         </div>
         <div class="content-main">
             <div class="kefu-group">
               <div class="m-groupmag">
                   <div class="groupmag-hd">
                     <div class="tit">客服分组</div>
                     <div class="opr j-export-import">
                       <!-- <a>导出</a>
                       <a>重构</a> -->
                     </div>
                   </div>
                   <div class="m-grouptree">
                     <div class="treesearch">
                       <div class="inp-wrap">
                         <input placeholder="搜索客服组名称" maxlength="30"  @input="Select_Group" v-model="Group_select">
                         <i data-v-469af010="" class="iconfont icon-sousuo"></i>
                       </div>
                     </div>

                   </div>
                   <div class="treelist">
                      <ul class="beginnodes">
                         <li class="treenode treenode-leaf">
                            <div class="nodename leafnode" @click="slideUp">
                              <div class="nameline">
                                <span class="iconfont icon-avatar-group"></span>
                                <span class="nametext">所有人&nbsp;<span class="count">({{SumUser1}})</span></span>
                              </div>
                              <div class="oprs" v-if="show" @click="dialogFormVisible = true">
                                    +新建一级分组
                              </div>
                            </div>
                         </li>
                      </ul>
                      <ul class="realnodes">
                         <li class="treenode treenode-leaf" :key="index" v-for="(i,index) in Tree">
                           <div class="nodename z-sel leafnode">
                             <div class="nameline" @click=Chick(i.id,i.child_node) style="cursor: pointer;">
                               <i class="iconfont icon-L"></i>
                               <span class="iconfont icon-avatar-group"></span>
                               <span title="新建分组" class="nametext">{{i.name}}&nbsp;<span class="count">({{i.count}})</span></span>
                             </div>
                             <div class="oprs" v-if="i.booleam">
                               <el-tooltip class="item" effect="dark" content="编辑客服组" placement="top-start">
                                   <a title="编辑客服组" class="iconfont icon-edit" @click="UpdateGroup(i.id,1,i.name)" ></a>
                               </el-tooltip>
                               <el-tooltip class="item" effect="dark" content="查看可接入渠道" placement="top-start">
                                   <a class="el-icon-view" @click="MinchannelShow(i.id)" ></a>
                               </el-tooltip>
                               <el-tooltip class="item" effect="dark" content="删除客服组" placement="top-start">
                                  <a title="删除客服组" class="iconfont icon-delete" id="auto-id-1575619861341" @click="DeleteGroup(i.id,1)"></a>
                               </el-tooltip>
                             </div>
                           </div>
                         </li>
                         <li id="node_wfz" class="treenode treenode-leaf treenode-last">
                           <div class="nodename z-sel leafnode">
                             <div class="nameline" @click="slideDown">
                               <span class="iconfont icon-L"></span>
                               <span class="iconfont icon-avatar-group"></span>
                               <span title="未分组" class="nametext">未分组&nbsp;<span class="count"></span></span>
                             </div>
                           </div>
                         </li>
                      </ul>
                   </div>
               </div>
               <el-dialog title="新建客服组" :visible.sync="dialogFormVisible">
                 <el-form >
                   <el-form-item label="分组名称" :label-width="formLabelWidth">
                     <el-input v-model="groupvalue" autocomplete="off" placeholder="请输入分组名称"></el-input>
                   </el-form-item>
                    <el-form-item label="可接入渠道" :label-width="formLabelWidth">
                          <el-select v-model="MiniChannelEnumModel" placeholder="请选择" style="width: 98%;">
                            <el-option
                            v-for="item in MiniChannelOption"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                            ></el-option>
                            </el-select>
                    </el-form-item>

                 </el-form>
                 <div slot="footer" class="dialog-footer">
                   <el-button @click="dialogFormVisible = false">取 消</el-button>
                   <el-button type="primary" @click="confirm">确 定</el-button>
                 </div>
               </el-dialog>
           <el-dialog title="可接入渠道" :visible.sync="dialogFormVisible1">
                 <el-form >
                   <el-form-item label="渠道名称:" :label-width="formLabelWidth">
                      <el-tag
                        style="margin-right:10px;"
                        v-for="(item,index) in MiniChannelGroupModel"
                        :key="index"
                        effect="dark">
                        {{ item.name }}
                    </el-tag>
                   </el-form-item>
                 </el-form>
                 <div slot="footer" class="dialog-footer">
                   <el-button @click="dialogFormVisible1 = false">取 消</el-button>
                 </div>
               </el-dialog>
                 <el-dialog title="修改" :visible.sync="dialogFormVisibleUpdate">
                 <el-form >
                   <el-form-item label="分组名称" :label-width="formLabelWidth">
                     <el-input v-model="UpdateDeleteModel.GroupName" autocomplete="off" placeholder="请输入分组名称"></el-input>
                   </el-form-item>
                        <el-form-item label="可接入渠道" :label-width="formLabelWidth">
                          <el-select v-model="MiniChannelEnumModel" placeholder="请选择" style="width: 98%;">
                              <el-option
                              v-for="item in MiniChannelOption"
                              :key="item.id"
                              :label="item.name"
                              :value="item.id"
                              ></el-option>
                              </el-select>
                    </el-form-item>
                 </el-form>
                 <div slot="footer" class="dialog-footer">
                   <el-button @click="dialogFormVisibleUpdate = false">取 消</el-button>
                   <el-button type="primary" @click="UpdateGroup(0,2)">确 定</el-button>
                 </div>
               </el-dialog>

                 <el-dialog title="删除" :visible.sync="dialogFormVisibleDelete">
                 <el-form >
                  <p>是否删除？</p>
                 </el-form>
                 <div slot="footer" class="dialog-footer">
                   <el-button @click="dialogFormVisibleDelete = false">取 消</el-button>
                   <el-button type="primary" @click="DeleteGroup(0,2)">确 定</el-button>
                 </div>
               </el-dialog>


               <el-dialog title="批量修改接待人数" :visible.sync="dialogFormVisibleBatch">
                 <el-form >
                   <el-form-item label="接待人数" :label-width="formLabelWidth">
                     <el-input v-model="Accesstothevolume" autocomplete="off" placeholder="请输入接待人数"></el-input>
                   </el-form-item>
                 </el-form> 
                 <div slot="footer" class="dialog-footer">
                   <el-button @click="dialogFormVisibleBatch = false">取 消</el-button>
                   <el-button type="primary" @click="Batch_Accesstothevolume">确 定</el-button>
                 </div>
               </el-dialog>

             </div>
             <div class="kefu-user">
               <div class="content-box">
                  <div class="staff_box">
                        <div class="title">客服列表</div>
                          <el-button type="primary" class="add"  style="margin-left:5px" v-bind:disabled="batch_is" @click="dialogFormVisibleBatch=true">批量修改接待人数</el-button>
                        <el-button type="primary" class="add" @click="add" @keypress.add="add" >新增客服</el-button>
                        <div class="search_box">
                          <el-input placeholder="请输入账号/姓名/手机号" v-model="Select.value1">
                            <input type="text" autocomplete="off" placeholder="请输入内容">
                          </el-input>
                          <i class="iconfont icon-sousuo" @click="Select_mobile"></i>
                        </div>
                           <el-select v-model="Select.RoleId" placeholder="所有角色" @change="SelectRole" >
                          <el-option
                            
                            v-for="item in option1"
                            :key="item.id"
                            :label="item.roleName" 
                            :value="item.id">
                          </el-option>
                        </el-select>
                        <div class="clear"></div>
                  </div>
                   
                 <div class="table_box">
                    <div >共{{SumUser}}个客服</div>
                    </br>
                   <el-table  ref="multipleTable" :data="tableData" tooltip-effect="dark"
                             style="width: 100%;" border stripe
                             @selection-change="handleSelectionChange" @select-all="select_all" @select="select">
                     <el-table-column fixed type="selection" width="55"></el-table-column>
                     <el-table-column prop="Account" label="帐号" ></el-table-column>
                     <el-table-column prop="NickName" label="昵称"  show-overflow-tooltip></el-table-column>
                     <el-table-column prop="RealName" label="姓名"  ></el-table-column>
                     <el-table-column prop="Mobile" label="手机号" ></el-table-column>
                     <el-table-column prop="RoleName" label="类型" ></el-table-column>
                      <el-table-column prop="RoleName" label="角色" ></el-table-column>
                    <!-- <el-table-column  prop="operate" label="操作">
                       <i class="el-icon-edit" style="cursor: pointer;"  prop="RoleName"  @click="Update()"></i>
                    </el-table-column> -->

                    <el-table-column
                           fixed="right"
                          label="操作"
                          width="100">
                          <template slot-scope="scope">
                             <i class="el-icon-edit" style="cursor: pointer;"  prop="RoleName"  @click="Update(scope.row.operate)"></i>
                               <i class="el-icon-delete" style="cursor: pointer;"  prop="RoleName"  @click="Delete(scope.row.operate)"></i>
                            <!-- <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
                            <el-button type="text" size="small">编辑</el-button> -->
                          </template>
                        </el-table-column>

                   </el-table>
                 </div>
              
                 <div class="pagination">
                    
                   <el-pagination
                    @current-change="List"
                      background
                     layout="total, prev, pager, next"
                     :total="SumUser" >
                   </el-pagination>
                 </div>
               </div>
             </div>
         </div>
     </div>
</template>

<script>
 import { Base64 } from 'js-base64'
    export default {
        name:'manage',
        props: [],
        data() {
          return {
            Accesstothevolume:"", //接入量
            DeleteFastreply: [], //是否选中
            batch_is:true,  //批量接入量
            Group_select:"",
            MiniChannelGroupModel:[],
            dialogFormVisible1:false,
            MiniChannelEnumModel:undefined,
            //渠道下拉列表
            MiniChannelOption:[],
            UpdateDeleteModel:{
                  Id:0,
                  GroupName:''
            },
            Select:{
              RoleId:0,
               value1:'',
               page:1,
               pageSize:10,
               Group:""
            },
            show:false,
            dialogFormVisible: false,
            dialogFormVisibleUpdate: false,
            dialogFormVisibleDelete: false,
             dialogFormVisibleBatch: false,
            formLabelWidth: '120px',
            groupvalue:'',
            value:'',
            option1: [{
              roleName: '全部',
              id: 0
            }],
            tableData:[
              
            ],
            options: [{
              value: '选项1',
              label: '黄金糕'
            }, {
              value: '选项2',
              label: '双皮奶'
            }],
            SumUser:0,
            SumUser1:0,
            Tree:[ 
            ],
              Tree1:[ 
            ],
            child_Type:1
          }
        },
        watch: {},
        mounted: function () {
              this.List(1);
        },
        created:function(){
          this.Total();
          this.Three();
          this.SelectList();
          this.Show();
          
        },
        methods: {
          MinchannelShow(id){
            let $this=this;
            $this.dialogFormVisible1=true;
            this.axios.get("GroupJoinMiniChannel/GroupJoinMiniChannel",{
              params:{
                Id:id
              }
            },{
              headers:{
                'Content-Type':'application/json'
              }
            }).then(function(data){
              $this.MiniChannelGroupModel=data.data;
            })
           
            
          },
          Show(){
            let $this=this;
            this.axios.get("MiniChannelEnum/SelectList",{
              headers:{
                'Content-Type':'application/json'
              }
            }).then(function(data){
              $this.MiniChannelOption=data.data;
            })
            
          },
          SelectRole(){
                 this.List(this.Select.page,this.Select.pageSize,this.Select.value1,this.Select.Group,this.Select.RoleId);
                 this.Total(this.Select.value1,this.Select.Group,this.Select.RoleId);
          },
            SelectList(){
              let $this=this;
              this.axios.get("Role/SelectList",{
                headers:{
                  'Content-Type':'application/json'
                }
              }).then(function(data){
                data.data.forEach(element => {
                   $this.option1.push(element)
                });
               
                  $this.Select.RoleId=$this.option1[0].id
              })
              
          },
          ThreeCLea(){
                 let $this=this;
                 $this.Tree.forEach(element => {
                   element.booleam=false;
                 });
          },
          Chick(a,b){
            let $this=this;
             this.ThreeCLea();
             if(this.show){
              this.show=false
            }
              $this.Select.Group=b+a;
            this.List($this.Select.page,$this.Select.pageSize,$this.Select.value1,$this.Select.Group,$this.Select.RoleId)

            //  this.List(1,10,$this.value1,b+a,$this.RoleId);

                // this.Total("",b+a);
                 this.Total($this.Select.value1,$this.Select.Group,$this.Select.RoleId);
            this.Tree.forEach(element => {
                if(a==element.id){
                  if(element.booleam){
                    element.booleam=false;
                  }
                  else
                  {
                    element.booleam=true;
                  }
                }
             });
             
          },
          Total(Modile,GroupId,RoleId){
             //初始化  客服总人数
          let $this=this;
          this.axios.get('User/SumUser',{params:{
            Mobile:Modile,
            GroupId:GroupId,
            RoleId:RoleId
          }},{
            headers:{
              'Content-Type':'application/json'
            }
          }).then(function(data){
            $this.SumUser=data.data;
            
           
            if($this.SumUser1==0){
               $this.SumUser1  = $this.SumUser;
            }
            
          })
          }, 
          //返回用户列表
          List(PageSize,PageNum,modile,GroupId,RoleId){
               PageNum=10;
              let $this = this;
            this.axios.get('User/List',{params:{
              pages:PageSize,
              pageNum:PageNum,
              Modile:modile,
              GroupId:GroupId,
              RoleId:RoleId
            },headers:{auditChannel:Base64.encode('获取用户列表')}}).then(function(data){
                $this.tableData=[];
              data.data.forEach(element => {
                $this.tableData.push({
                  Id:element.id,
                   Account:element.account,
                NickName: element.nickName,
                RealName:element.realName,
                  Mobile:element.mobile,
                  RoleName:element.roleName,
                  operate:element.id
                });
              
              });
            })
          },
          //手机号查询
            Select_mobile(){
               let $this = this;
          this.List($this.Select.page,$this.Select.pageSize,$this.Select.value1,$this.Select.Group,$this.Select.RoleId)
            this.Total($this.Select.value1,$this.Select.Group,$this.Select.RoleId);
            },
            //树
            Three(){
                let $this=this;
                this.axios.get("Group/createTree",{
                  headers:{
                    'Content-Type':'application/json'
                  }
                }).then(function(data){
                  
                 $this.Tree=data.data;
                 $this.Tree1=data.data;
                 
                })
            },
          slideUp(){
            let $this=this;
            this.ThreeCLea();
            
             $this.Select.Group="";
             this.List($this.Select.page,$this.Select.pageSize,$this.Select.value1,$this.Select.Group,$this.Select.RoleId)
              this.Total($this.Select.value1,$this.Select.Group,$this.Select.RoleId);
            this.show=true
          },
          slideDown(){
            let $this=this
            this.ThreeCLea();
           $this.Select.Group="";
           this.List($this.Select.page,$this.Select.pageSize,$this.Select.value1,$this.Select.Group,$this.Select.RoleId)
            this.Total($this.Select.value1,$this.Select.Group,$this.Select.RoleId);
            if(this.show){
              this.show=false
            }
          },
          getCheckChannel(channelId,groupId,callback){
            let $this = this;
          let result=false;
            this.axios.get(`GroupJoinMiniChannel/AllocateOrNot?channelId=${channelId}&groupId=${groupId}`).then(function({data}){
              if(!data){
                $this.$message({type:'error',message:'该渠道已被其他组接入'});
                result= true;
              }else{
                result=false;
              }
              callback(result)
            })
          
          },
          confirm(){
            var $this=this;
            var MiniChannel=[];
            if ($this.MiniChannelEnumModel==0) {
                this.$confirm('请选择可接入渠道', '提示', {
                  type: 'warning',
                  showCancelButton:false
                })
                return;
            }
            let channelId= $this.MiniChannelEnumModel;
            $this.getCheckChannel(channelId,-1,(result)=>{
              if(result){
              }else{
                       var Group={
              GroupName:$this.groupvalue,
              MaxReception:0,
              PersonlnCharge:"",
              ParentId:0,
              sort:0
            };
            $this.axios.post("Group/Add",Group,{
              headers:{
                'Content-Type':'application/json'
              }
            }).then(function(data){
                  if(data.data.status==200 || data.data.code==200){
                  // $this.MiniChannelEnumModel.forEach(element => {
                  //   var MiniChannelMOdel={
                  //     GroupId:data.data.id,
                  //     MiniChannelId:element,
                  //     CreateTime:'2019-1-1'
                  //   };
                  //   MiniChannel.push(MiniChannelMOdel);
                  // });
                    var MiniChannelMOdel={
                      GroupId:data.data.id,
                      MiniChannelId:$this.MiniChannelEnumModel,
                      CreateTime:'2019-1-1'
                    };
                    MiniChannel.push(MiniChannelMOdel);
                  $this.axios.post("GroupJoinMiniChannel/Add",MiniChannel,{
                    headers:{
                      'Content-Type':'application/json'
                    }
                  }).then(function(data1){

                      if(data1.data.message=="成功"){
                          $this.$message(data1.data.message);
                          $this.dialogFormVisible=false;
                            $this.Three();
                            $this.MiniChannelEnumModel=0;
                      }
                      else{
                        $this.$message.error(data1.data.message);
                      }
                  })
                  }
                  else{
                    $this.$message.error(data.data.message)
                  }
                })
              }
            })
          },
          select_all(selection){//全选

            			let $this = this

                $this.DeleteFastreply = []
                selection.forEach(element => {
                  var elem = element.Id
                  $this.DeleteFastreply.push(elem)
                })

                if ($this.DeleteFastreply.length > 0) {
                  $this.batch_is = false
                } else {
                  $this.batch_is = true
                }
                  console.log($this.DeleteFastreply)
          },
          select(selection, row){//选中某行
          
            			let $this = this
                  $this.DeleteFastreply = []
                  selection.forEach(element => {
                    var elem = element.Id
                    $this.DeleteFastreply.push(elem)
                  })

                if ($this.DeleteFastreply.length > 0) {
                  $this.batch_is = false
                } else {
                  $this.batch_is = true
                }
                console.log($this.DeleteFastreply)

          },
          handleSelectionChange(){//选项发生变化
        
          },
          add(){//新增客服
            // this.$emit('id','edit');
             this.$emit('id','edit',0);
          },
          Update(id){
            this.$emit('id','edit',id);
          },
          //修改分组名称
          UpdateGroup(id,Type,name){
            let $this=this;
            if(Type==1){
                $this.dialogFormVisibleUpdate=true;
                $this.UpdateDeleteModel.Id=id;
                $this.UpdateDeleteModel.GroupName=name;
                $this.axios.get("GroupJoinMiniChannel/AllMiniChannelId",{
                params:{
                 GroupId: id
                }
              },{
                headers:{
                  'Content-Type':'application/json'
                }
              }).then(function(data){
                if(data.data instanceof Array && data.data.length>0){
                  $this.MiniChannelEnumModel=data.data[0].miniChannelId
                }
              })

            }
            else if(Type==2){
                var MiniChannel=[];
                  if ($this.MiniChannelEnumModel==0 || $this.MiniChannelEnumModel==undefined) {
                      this.$confirm('请选择可接入渠道', '提示', {
                        type: 'warning',
                        showCancelButton:false
                      })
                      return;
                  }
                   $this.getCheckChannel($this.MiniChannelEnumModel,$this.UpdateDeleteModel.Id,(result)=>{
                     if(result){
                       return false
                     }
                      $this.axios.post("Group/Update?Id="+  $this.UpdateDeleteModel.Id+"&GroupName="+ $this.UpdateDeleteModel.GroupName,{
                        headers:{
                          'Content-Type':'application/json'
                        }
                      }).then(function(data){
                          if(data.data.message=="成功"){
                                $this.axios.post("GroupJoinMiniChannel/Delete?GroupId="+$this.UpdateDeleteModel.Id,{
                                  headers:{
                                    'Content-Type':'application/json'
                                  }
                                }).then(function(data1){
                                  if(data1.data.message=="成功"){
                                      var MiniChannelMOdel={
                                          GroupId:$this.UpdateDeleteModel.Id,
                                          MiniChannelId:$this.MiniChannelEnumModel,
                                          CreateTime:'2019-1-1'
                                        };
                                        MiniChannel.push(MiniChannelMOdel);
                                    $this.axios.post("GroupJoinMiniChannel/Add",MiniChannel,{
                                        headers:{
                                          'Content-Type':'application/json'
                                        }
                                      }).then(function(data2){

                                          if(data2.data.message=="成功"){
                                              $this.$message(data2.data.message);
                                              $this.dialogFormVisible=false;
                                                $this.Three();
                                                  //  alert(data.data.message);
                          
                                              $this.dialogFormVisibleUpdate=false;
                                              $this.Three();
                                              $this.MiniChannelEnumModel=0;

                                          }
                                          else{
                                            $this.$message.error(data2.data.message);
                                          }
                                      })    
                                  }
                                  else{
                                    $this.$message.error(data1.data.message);
                                  }
                                })
                          }
                          else{
                            $this.$message.error(data.data.message);
                          }
                        })
                   })
               
            }
          },
          //删除分组
          DeleteGroup(id,Type){
            let $this=this;
            $this.UpdateDeleteModel.Id=id
            $this.$confirm('此操作将永久删除该组, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                this.axios.get("Group/exists",{
                  params:{GroupId: $this.UpdateDeleteModel.Id} },
                  {headers:{'Content-Type':'application/json'}}).then(function(data){
                    if(data.data>0){
                        $this.$message({
                              type: 'error',
                              message: '请必须移除分组中的人!'
                          });
                    }
                    else
                    {
                      $this.axios.post('Group/Delete?Id='+$this.UpdateDeleteModel.Id,{
                        headers:{'Content-Type':'application/json'}
                      }).then(function(data1){
                        if(data1.data.message=="成功"){
                           $this.$message({
                              type: 'success',
                              message: '删除成功!'
                          });
                           $this.dialogFormVisibleDelete=false;
                           $this.Three();
                        }
                        else{
                            $this.$message({
                              type: 'error',
                              message: data1.data.message
                          });
                        }
                      })
                    }
                  })
        
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
           
          },
          //删除
          Delete(id){
                              let $this=this;
              var mymessage=confirm("是否删除？");
              if(mymessage==true)
              {
                  $this.axios.post("User/Delete?id="+id,{
                    headers:{
                      'Content-Type':'application/json'
                    }
                  }).then(function(data1){
                    if(data1.data.message=="成功"){
                        $this.$message(data1.data.message);
                            // $this.Total();
                            // $this.Three();
                            // $this.SelectList();
                            $this.List();
                    }
                    else{
                         $this.$message.error(data1.data.message)
                    }
                  })


               
              }
              else if(mymessage==false)
              {
               
              }
          },
          Select_Group(){

            let $this=this;

            // $this.Tree.forEach(element => {
            //   if(element.name.search($this.Group_select)!=-1){
            //     alert("x")
            //   }
            // });
            $this.Tree=[];
            if($this.Group_select==""){
               $this.Tree=$this.Tree1;
            }
            else{
              $this.Tree1.forEach(element => {
                if(element.name.search($this.Group_select)!=-1){
                $this.Tree.push(element);
                }
              });
            }
            // alert(this.Group_select)
            // console.log()
          },
          //批量修改接入量
          Batch_Accesstothevolume(){
                let $this=this;
              var bolearm=true;
              if($this.Accesstothevolume==""){
                bolearm=false;
                $this.$message.error("请输入接入量!")
              }
              
   
              if(bolearm){
                console.log($this.Accesstothevolume)
                console.log($this.DeleteFastreply)

               $this.axios.post("User/Batch_Accesstothevolume?count="+$this.Accesstothevolume,$this.DeleteFastreply,{
                 headers:{
                   'Content-Type':'application/json'
                 }
               }).then(function(data){
                 if(data.data.message=="成功"){
                      $this.$message(data.data.message)
                      $this.dialogFormVisibleBatch=false;
                      $this.Total();
                      $this.List();
                      $this.Accesstothevolume="";
                       
                 }
                 else{
                    $this.$message.error(data.data.message)
                 }

               })
                
              }
          }
        }
    }
</script>

<style scoped>
 .search_box .el-input__inner{
    background-color:transparent;
    border:none;
    height: 30px;
    line-height: 30px;
  }
  .el-input__icon {
    line-height: 28px;
  }
  .contains{
     height: 100%;
     overflow: auto;
     display: -webkit-box;
     display: -ms-flexbox;
     display: flex;
     -webkit-box-orient: vertical;
     -webkit-box-direction: normal;
     -ms-flex-direction: column;
     flex-direction: column;
     position: relative;
     padding-top: 10px;
     width: 100%;
     -webkit-box-sizing: border-box;
     box-sizing: border-box;
   }
  .content-tit {
    height: 60px;
    line-height: 46px;
  }
  .content-tit h2{
    font-weight: normal;
    font-size: 24px;
  }
  .kefu-group{
    width:250px;
    text-align: left;
    border: solid 1px #ddd;
    overflow-x: hidden;
    min-width: 250px;
  }
  .groupmag-hd{
    min-height: 40px;
    display: flex;
    line-height: 40px;
    border-bottom: solid 1px #ddd;
    padding: 0 8px;
    background-color: #f7f7fa;
  }
.groupmag-hd .tit {
    min-width: 100px;
    font-size: 14px;
    padding-left: 8px;
  }
 .groupmag-hd .opr {
    text-align: right;
    width: 100%;
  }
 .groupmag-hd .opr a{
    margin-right: 10px;
    color: #337eff;
  }
  .m-groupmag {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  .content-main{
    display: flex;
    position: relative;
    height: calc(100% - 60px);
  }
   .m-groupmag .m-grouptree .treesearch {
     padding: 10px 15px;
   }
   .treesearch .inp-wrap{
     border: solid 1px #ddd;
     position: relative;
   }
   .treesearch .inp-wrap input {
     width: 80%;
     border: none;
     height: 30px;
     padding-left: 10px;
   }

   .treesearch .inp-wrap .iconfont {
     position: absolute;
     top: 5px;
     right: 8px;
     color: #999;
   }
   .icon-search:before {
     content: "\e60b";
   }
  .treelist{
    padding:0 15px;
  }
  .beginnodes{
    list-style:none;
  }
 .treenode .nodename{
   line-height:30px;
   min-height:30px;
   color:#999;
   font-size:12px;
 }

  .treenode .nodename .nameline:hover span{
    color:#337eff;
  }
   .treenode .nodename .nameline .icon-L{
    margin-left:8px;
    position: relative;
    top: -5px;
    color:#999;
  }
 .treenode .nodename .nameline:hover .icon-L{
    color:#999;
  }
  .oprs{
    padding-left: 38px;
    color:#337eff;
    font-size:12px;
  }
  .oprs a{
    margin-right:4px;
  }
  .icon-edit{
    font-size:14px;
  }

  /*表格*/
   .kefu-user{
     width:100%;
     height:100%;
   }
  .content-box{
    padding:20px;
  }
   .title{
     font-size:16px;
     padding:0px 0 20px 0;
     float: left;
   }
   .content-box .el-input-group{
     float: right;
     width:320px;
   }
   .add{
     float: right;
   }
   .import{
     float: right;
   }
   .export{
     float: right;
     margin-right:10px;
   }
   .delete{
     float: right;
     margin-right:10px;
   }
   .staff_box .el-select{
     float: right;
     width:140px;
     margin-left:15px;
   }
  .search_box{
    float: right;
    border: 1px solid #DCDFE6;
    background-color:#fafafa;
    padding-right:10px;
    margin:0 5px 0 15px;
    border-radius:4px;
  }
  .icon-sousuo{
    font-size:20px;
    cursor: pointer;
    vertical-align: middle;
  }
  .batch{
    float: right;
    margin-right:15px;
    background-color:#999999;
    border-color:#999;
  }
  .table_box{
    margin-top:50px;
  }
  .pagination{
    text-align: right;
  }
  .el-pagination{
    text-align: right;
    margin-top:50px;
    display: inline-block;
  }
</style>
<style>
 
</style>





// WEBPACK FOOTER //
// src/components/manage/staff/manage.vue